<template>
    <a href="javascript:void(0)" class="pic-item" @click="jumpDetails(data.share, data.space_url)" v-if="!data.adv_data">
        <template v-if="!data.isTopic">
            <div style="min-height: 50px">
                <img v-if="isPattingAll" :src="data.cover ? data.cover : ''" alt="">
                <img v-if="!isPattingAll" :src="data.image_cover ? data.image_cover:'' " alt="">
                <div class="s_user">    
                    <div class="flex align-center">
                        <div>
                            <img :src="data.user?data.user.image:''" alt="">
                            <i :class="[data.user ? data.user.gender == 'm' ? 'man' : 'women' : '']"></i>
                        </div>
                        <span class="van-ellipsis">{{data.user?data.user.nickname:''}}</span>
                    </div>
                    <div v-if="type === 2" class="play_count">{{data.views}}</div>
                </div>
            </div>
            <div class="intro">
                <div v-if="type === 2" class="title_s flex align-center"><span>#</span>{{data.tag?data.tag.title:''}}</div>
                <p>{{data.content}}</p>
                <div class="dianzan" v-if="!(type === 2)">
                    <span>{{data.comment_num}}</span>
                    <span>{{data.like}}</span>
                </div>
            </div>
        </template>
        <template v-if="data.isTopic">
            <div @click="jumpTopicDet(data.tid)" class="topic" :style="{'background': 'linear-gradient(135deg, #'+ (data.bg[0]?data.bg[0]:'FF7B9A') +' 0%, #'+ (data.bg[1]?data.bg[1]:'FF1544') +' 100%)'}">
                <div class="infoBox flex align-center justify-center flex-column">
                    <p class="title">{{data.title}}</p>
                    <p class="content van-multi-ellipsis--l2">{{data.desc}}</p>
                    <span class="findBtn">查看</span>
                </div>
            </div>
        </template>
    </a>
</template>

<script>
import {navigate} from '@/pages/index/custom'

export default {
    props: {
        data: {
            type: [Object],
            default: {a: 1}
        },
        id: {
            typee: [String],
            default: ""
        },
        type: {
            type: [String, Number],
            default: ''
        },
        isPattingAll: {
            type: Boolean,
            default: false
        },
        isTopic: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            
        }
    },
    methods: {
        jumpDetails(url, url2) {
            let c_url = url ? url : url2 ? url2 : ''
            if(c_url) {
                navigate('', c_url)
            }
        },
        // 话题详情
        jumpTopicDet(id) {
            navigate({path: "/patTopDetails", query: {id: id}})
        }
    },
    created() {
    },
    mounted() {
        
    },
}
</script>


<style lang="less" scoped>
.topic {
    width: 100%;
    position: relative;
    border-radius: 0.375rem;
    height: 9.75rem;
    .infoBox {
        box-sizing: border-box;
        padding: 0 20px;
        text-align: center;
    }
    .title {
        font-size:20px;
        font-weight:600;
        color:rgba(255,255,255,1);
    }
    .content {
        font-size:12px;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:16px;
    }
    .findBtn {
        width:64px;
        height:30px;
        border-radius:125px;
        border:2px solid rgba(255,255,255,.7);
        line-height: 26px;
        text-align: center;
        font-size:14px;
        font-weight:400;
        color:rgba(255,255,255,1);
        margin-top: .5rem;
        box-sizing: border-box;
    }
    div {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 0.5rem;
        position: relative;
    }
    &::after {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: url(../assets/img/icon_msg.png) no-repeat -9px -9px;
        background-size: 80px 80px;
        opacity: 0.3;
    }
}
.title_s {
    width: auto;
    height: 1.25rem;
    line-height: 1.25rem;
    font-size:12px;
    font-weight:400;
    color:rgba(255,76,103,1);
    background: #ffedf0;
    border-radius: 2px;
    display: inline-block;
    padding-right: .25rem;
    overflow: hidden;
    span {
        width: 1.25rem;
        height: 1.25rem;
        text-align: center;
        font-size: 14px;
        background: #ffdce1;
        margin-right: .25rem;
        display: inline-block;
    }
}
    .pic-item {
        width: 100%;
        border-radius: .375rem;
        overflow: hidden;
        box-shadow: 0px 2px 5px 0px #ccc;
        float: left;
        margin-bottom: .75rem;
    }
    .pic-item > div {
        position: relative;
        width: 100%;
        max-height: 16.875rem;
        overflow: hidden;
        border-radius: .375rem;
    }
    .pic-item > div > img {
        width: 100%;
        height: auto;
    }
    .pic-item .intro {
        box-sizing: border-box;
        padding: .5rem;

    }
    .pic-item .intro p {
        font-size:14px;
        font-weight:500;
        color:rgba(34,34,34,1);
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }
    .s_user {
        position: absolute;
        height: 2.25rem;
        bottom: .375rem;
        width: 100%;
        box-sizing: border-box;
        padding: 0 .75rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .s_user div {
        position: relative;
    }
    .s_user div i {
        position: absolute;
        width: .625rem;
        height: .625rem;
        right: 0;
        bottom: 0;
        
    }
    .women {
        background: url(../assets/img/icon_women.png) no-repeat center center;
        background-size: 100% 100%;
    }
    .man {
        background: url(../assets/img/icon_man.png) no-repeat center center;
        background-size: 100% 100%;
    }
    .s_user img {
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 50%;
        overflow: hidden;
        border:1px solid rgba(238,238,238,1) !important;
    }
    .s_user span {
        font-size:12px;
        font-weight:400;
        color: #fff;
        margin-left:4px;
        max-width: 60px;
    }
    .play_count {
        font-size:12px;
        font-weight:400;
        color:rgba(255,255,255,1);
        padding-left: 10px;
        background: url(../assets/img/icon_play_num.png) no-repeat center left;
        background-size: 10px 10px;
    }
    .dianzan {
        display: flex;
        align-items: center;
        margin-top: .75rem;
    }
    .dianzan span {
        padding-left: 1.375rem;
        font-size:12px;
        font-weight:400;
        color:rgba(34,34,34,1);
    }
    .dianzan span:nth-child(1) {
        background: url(../assets/img/line@2x.png) no-repeat center left;
        background-size: 1.25rem 1.25rem;
    }
    .dianzan span:nth-child(2) {
        background: url(../assets/img/toolbar.png) no-repeat center left;
        background-size: 1.25rem 1.25rem;
        margin-left: 1.375rem;
    }
</style>